module.exports = __webpack_public_path__ + "static/media/ilights_rgb.a35972ed.svg";